import styled from "styled-components";

const Modal = styled.div`
	position: fixed;
	z-index: 10001;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	background: linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%),
		linear-gradient(0deg, rgba(255, 128, 47, 0.2) 0%, rgba(255, 128, 47, 0.2) 100%),
		linear-gradient(0deg, rgba(26, 27, 43, 0.6) 0%, rgba(26, 27, 43, 0.6) 100%),
		radial-gradient(50% 50% at 50% 50%, rgba(80, 46, 128, 0.07) 0%, rgba(0, 0, 0, 0.9) 100%);
	background-blend-mode: normal, color, normal, normal;
	backdrop-filter: blur(12.5px);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	gap: 20px;

	svg {
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
`;

const AlertWrapper = styled.div`
	width: 280px;
	border-radius: 25px;
	background: var(--modal-bg);
	min-height: 110px;
	padding: 20px;
	display: flex;
	align-items: center;
	flex-direction: column;
	position: relative;
	gap: 10px;

	@media (min-width: 1024px) {
		width: 460px;
		padding: 30px;
	}
`;

const TitleWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 2px;
`;

const Title = styled.div`
	color: #18bb0c;
	text-align: center;
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.3px;
`;

const ContentWrapper = styled.div`
	border-radius: 15px;
	background: linear-gradient(180deg, rgba(24, 187, 12, 0.1) 0%, rgba(6, 115, 6, 0.1) 100%);
	display: flex;
	padding: 15px 0px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	align-self: stretch;
	flex-direction: column;
`;

const PlayNowButton = styled.div`
	color: #fff;
	text-align: center;
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.3px;
	display: flex;
	height: 44px;
	padding: 0 20px 0 20px;
	justify-content: center;
	align-items: center;
	gap: 5px;
	border-radius: 25px;
	background: linear-gradient(180deg, var(--main-color-light) 0%, var(--main-color-dark) 100%);
`;

const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 20px;

	.modal-close-icon {
		width: 44px;
		height: 44px;
	}
`;

const ContentMsg = styled.div`
	color: #eff0f6;
	text-align: center;
	font-size: 13px;
	font-weight: 400;
	line-height: 16px;
	letter-spacing: 0.5px;
`;

const ContentDescription = styled.div`
	color: #eff0f6;
	text-align: center;
	font-size: 13px;
	font-weight: 400;
	line-height: 16px;
	letter-spacing: 0.5px;
`;

export {
	AlertWrapper,
	ButtonWrapper,
	ContentDescription,
	ContentMsg,
	ContentWrapper,
	Modal,
	PlayNowButton,
	Title,
	TitleWrapper,
};
